import { useEffect, type ReactNode } from 'react';

interface SiteLayoutProps {
  children: ReactNode;
  title?: string;
}

/** Page-level wrapper: sets the document title. Navbar/Footer live in the persistent AppShell. */
export default function SiteLayout({ children, title }: SiteLayoutProps) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  return <>{children}</>;
}